import React from 'react';
import { Document, Page, Text, View, Font } from '@react-pdf/renderer';

// Font registration
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});

// Utility to chunk array
function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}



const TableHeader = ({CourseName , BatchName}) => (
  <>
    {/* Header */}
    <View style={{ width: '100%', height: "20px", flexDirection: "row" }}>
      <View style={{ width: '4%', height: "100%" }}></View>
      <View style={{ width: '96%', height: "100%", flexDirection: 'row', borderTop: '1.5px solid black', borderLeft: "1.5px solid black", borderRight: "1.5px solid black" }}>
        <View style={{ width: '29.33%', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Training Programme :</Text>
        </View>
        <View style={{ width: '62.33%', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{CourseName}</Text>
        </View>
        <View style={{ width: '18.33%', justifyContent: 'center', alignItems: 'flex-end' }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Batch :</Text>
        </View>
        <View style={{ width: '35.33%', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{BatchName}</Text>
        </View>
      </View>
    </View>
    <View style={{ width: '100%', flexDirection: 'row', height: "18px" }}>
      <View style={{ width: '4%' }}></View>
      <View style={{ width: '96%', flexDirection: 'row', border: '1.5px solid black' }}>
        <View style={{ width: '15%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'center', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Code</Text>
        </View>
        <View style={{ width: '30%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'center', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Name</Text>
        </View>
        <View style={{ width: '20%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'center' }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Qualification</Text>
        </View>
        <View style={{ width: "17.5%", borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'center' }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Grade</Text>
        </View>
        <View style={{ width: "17.5%", justifyContent: 'center', alignItems: 'center', paddingLeft: 5 }}>
          <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Sign</Text>
        </View>
      </View>
    </View>
  </>
);

// Main PDF component
const StudentListR = ({data}) => {
  const rowChunks = chunkArray(data, 30);


  const CourseName = data.length > 0 ? data[0].Course_Name : "N/A";
  const BatchName = data.length > 0 ? data[0].Batch_Code : "N/A";

  return (
    <Document>
      <Page size="A4" style={{ padding: 30, paddingLeft: 20, fontSize: 10 }}>
        <View style={{ flexDirection: 'column', width: "100%" }}>
         

          {/* Table */}
          {rowChunks.map((chunk, chunkIdx) => (
            <View key={chunkIdx} break={chunkIdx !== 0}>
              <TableHeader  CourseName={CourseName} BatchName = {BatchName}/>
              {chunk.map((student, idx) => (
                <View key={idx + chunkIdx * 30} style={{ width: '100%', height: "24px", flexDirection: "row" }}>
                  <View style={{ width: '4%', justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{idx + 1 + chunkIdx * 30}</Text>
                  </View>
                  <View style={{ width: '96%', flexDirection: 'row', border: '1.5px solid black', borderTop: 'none' }}>
                    <View style={{ width: '15%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{student.Student_Code}</Text>
                    </View>
                    <View style={{ width: '30%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{student.Student_Name}</Text>
                    </View>
                    <View style={{ width: '20%', borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{student.Qualification}</Text>
                    </View>
                    <View style={{ width: "17.5%", borderRight: '1.5px solid black', justifyContent: 'center', alignItems: 'center' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{student.Grade}</Text>
                    </View>
                    <View style={{ width: "17.5%", justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 5 }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}></Text>
                    </View>
                  </View>
                </View>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default StudentListR;
